module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content body-reg-student background-reg-student"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card reg-student-card"
  }, [_c('div', {
    staticClass: "card-content reg-student-card-content"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-md-8 reg-student-title"
  }, [_vm._v("ĐĂNG KÝ TÀI KHOẢN HỌC SINH")]), _c('div', {
    staticClass: "row"
  }, [(_vm.error) ? _c('div', {
    staticClass: "col-md-12 reg-student-alert"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))])])]) : _vm._e(), (_vm.socialType === 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: [_vm.isSubmitStep && (_vm.username.length < 3 || this.checkName !== null) ? 'error' : '']
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tên đăng nhập *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Nhập",
      "required": "required"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: [_vm.isSubmitStep && _vm.fullname.length === 0 ? 'error' : '']
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tên hiển thị *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fullname",
      "type": "text",
      "required": "required",
      "maxlength": "125",
      "placeholder": "Nhập"
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }
    }
  })])]), (_vm.socialType === 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('md-fg-input', {
    class: [_vm.isSubmitStep && !_vm.validMail ? 'error' : ''],
    attrs: {
      "label": "Email *",
      "labelFloating": false,
      "type": "text",
      "required": true,
      "placeholder": "example@gmail.com"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1) : _vm._e(), (_vm.socialType === 2) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('md-fg-input', {
    attrs: {
      "label": "Email *",
      "labelFloating": false,
      "type": "text",
      "disabled": "disabled",
      "placeholder": "example@gmail.com"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: [_vm.isSubmitStep && _vm.phone_number.length === 0 ? 'error' : '']
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Số điện thoại")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone_number),
      expression: "phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone_number",
      "autocomplete": "off",
      "placeholder": "Nhập",
      "maxlength": "10",
      "required": true
    },
    domProps: {
      "value": (_vm.phone_number)
    },
    on: {
      "keypress": _vm.isAllow,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone_number = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('md-fg-input', {
    class: [_vm.isSubmitStep && _vm.isDate ? 'error' : ''],
    attrs: {
      "label": "Ngày sinh của bạn",
      "labelFloating": false,
      "type": "date",
      "required": false
    },
    model: {
      value: (_vm.birthday),
      callback: function($$v) {
        _vm.birthday = $$v
      },
      expression: "birthday"
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group custom-form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn trường học")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "school_id",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSchool($event)
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "true",
      "disabled": "disabled"
    }
  }, [_vm._v("Chọn")]), _vm._l((_vm.schools), function(o, index) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2)])]), _c('div', {
    staticClass: "col-md-3 col-xs-6 reg-student-grade"
  }, [_c('div', {
    staticClass: "form-group custom-form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn khối lớp")]), _c('itemGrade', {
    attrs: {
      "selected_school_id": _vm.isSelectedSchool ? _vm.selectedSchool : 0,
      "grades": _vm.grades,
      "schools": _vm.schools
    },
    on: {
      "onGradeChange": _vm.onGradeChanged
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _c('div', {
    staticClass: "reg-student-beehive"
  }, [_c('BeeHive', {
    attrs: {
      "lstItems": _vm.subjects
    },
    on: {
      "onlstItems": _vm.onlstSubjects
    }
  })], 1), _c('div', {
    staticClass: "reg-student-beehive-mobile"
  }, [_c('BeeHiveMobile', {
    attrs: {
      "lstItemsMobile": _vm.subjects
    },
    on: {
      "onlstItemsMobile": _vm.onlstSubjectsMobile
    }
  })], 1)]), _c('br'), _c('div', {
    staticClass: "row"
  }, [(_vm.socialType === 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: [_vm.isSubmitStep && this.password.length < 6 ? 'error' : ''],
    staticStyle: {
      "position": "relative"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Mật khẩu đăng nhập *")]), ((_vm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "password",
      "required": "required",
      "placeholder": "Nhập",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "password",
      "required": "required",
      "placeholder": "Nhập",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "password",
      "required": "required",
      "placeholder": "Nhập",
      "type": _vm.passwordType
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": _vm.checkPassword,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), (_vm.passwordType === 'text') ? _c('i', {
    staticClass: "material-icons reg-student-icon-password",
    on: {
      "click": _vm.switchVisibility1st
    }
  }, [_vm._v("visibility")]) : _c('i', {
    staticClass: "material-icons reg-student-icon-password",
    on: {
      "click": _vm.switchVisibility1st
    }
  }, [_vm._v("visibility_off")])])]) : _vm._e(), (_vm.socialType === 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: [_vm.isSubmitStep && (!this.matched || this.second_password.length < 6) ? 'error' : ''],
    staticStyle: {
      "position": "relative"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nhập lại mật khẩu *")]), ((_vm.secondPasswordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.second_password),
      expression: "second_password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "second_password",
      "required": "required",
      "placeholder": "Nhập",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.second_password) ? _vm._i(_vm.second_password, null) > -1 : (_vm.second_password)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        var $$a = _vm.second_password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.second_password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.second_password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.second_password = $$c
        }
      }
    }
  }) : ((_vm.secondPasswordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.second_password),
      expression: "second_password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "second_password",
      "required": "required",
      "placeholder": "Nhập",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.second_password, null)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        _vm.second_password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.second_password),
      expression: "second_password"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "second_password",
      "required": "required",
      "placeholder": "Nhập",
      "type": _vm.secondPasswordType
    },
    domProps: {
      "value": (_vm.second_password)
    },
    on: {
      "keyup": _vm.checkPassword,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.second_password = $event.target.value
      }
    }
  }), (_vm.secondPasswordType === 'text') ? _c('i', {
    staticClass: "material-icons reg-student-icon-password",
    on: {
      "click": _vm.switchVisibility2nd
    }
  }, [_vm._v("visibility")]) : _c('i', {
    staticClass: "material-icons reg-student-icon-password",
    on: {
      "click": _vm.switchVisibility2nd
    }
  }, [_vm._v("visibility_off")])])]) : _vm._e(), (_vm.socialType === 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.siteKey
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1) : _vm._e(), _vm._m(2), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "reg-student-btn-validate btn",
    on: {
      "click": _vm.validateRegister
    }
  }, [_vm._v("Đăng ký")])])]), _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "reg-student-btn-cancel btn",
    on: {
      "click": _vm.backLogin
    }
  }, [_vm._v("Quay lại")])])])])])]), _c('div', {
    staticClass: "clearfix"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 reg-student-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Obee_Logo_140@2x.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 reg-student-subject"
  }, [_c('p', [_vm._v("Môn học thế mạnh của bạn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "reg-student-content"
  }, [_vm._v("Bằng cách chọn \"Đăng ký\" bạn đồng ý với "), _c('span', [_vm._v("Điều khoản sử dụng ")]), _vm._v("và "), _c('span', [_vm._v("Chính sách bảo mật ")]), _vm._v("của chúng tôi.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6686f790","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/RegisterStudent.vue
// module id = 1590
// module chunks = 0